import React from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PAGE } from "../constants/page";
import { useAppDispatch } from "../redux/hooks";
import "../styles/components/PatientCard.scss";
import Utility from "../utility/Utility";
import { patientName, updatedPatient } from "../redux/reducers/PatientSlice";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";

const PatientCard = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const navigateToDetails = () => {
    navigate(PAGE.VIEW_PATIENT_DETAILS.replace(":id", props.data.resource.id));
    dispatch(updatedPatient(false));
  };
  const patient = props.data.resource;
  return (
    <div className="patientCard">
      <div className="patientCardInner">
        <div className={`left`}>
          <div className="text-center left-inner">
            <img src={`/icons/${patient?.gender || "male"}.svg`} alt="" />
            <span className={patient?.gender || "male"}>
              {patient?.gender ? (
                <Trans i18nKey={patient?.gender}></Trans>
              ) : (
                <Trans i18nKey={"unavailable"} />
              )}
            </span>
          </div>
        </div>
        <div className="right">
          <h5 className="patientDeatilsBold text-capitalize">
            {Utility.patientName(patient?.name)}
          </h5>
          <h5 className="patientDeatilsBoldSm">
            <Trans i18nKey={Utility.getIDString(patient)}></Trans> -{" "}
            {Utility.getIDNumber(patient) === "unavailable" ? (
              <Trans i18nKey="unavailable"></Trans>
            ) : (
              Utility.getIDNumber(patient)
            )}
          </h5>
          <span className="patientDeatilsReg">
            {Utility.getAge(patient?.birthDate)} <br></br>
            <Trans i18nKey={"dob"}></Trans> :{" "}
            {Utility.formatDate(patient?.birthDate) || (
              <Trans i18nKey={"unavailable"} />
            )}
          </span>
          <div style={{ marginTop: "3px" }}>
            <img src="/icons/contact.svg" alt="" />{" "}
            <span className="patientDeatilsReg">
              {(patient?.telecom && patient?.telecom[0]?.value) || (
                <Trans i18nKey={"unavailable"} />
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="text-end">
        <span className="viewDetails" onClick={navigateToDetails}>
          <span className="align-middle">
            <Trans i18nKey={"view_details"}></Trans>
          </span>
          <img className="ms-1 align-middle" src="/icons/forward.svg"></img>
        </span>
      </div>
    </div>
  );
};

export default ErrorBoundaryHandler(PatientCard);
